import React from "react";
import Chart from "./highcharts/Chart";
import highcharts3d from "highcharts/highcharts-3d";
import Highcharts from "highcharts";
import { UseContextData } from "../../../context/dateContext";

highcharts3d(Highcharts);

const TicketsResolutionChart = ({ filter = ["tickets"] }) => {
  const { isDarkTheme } = UseContextData();

  const chartOptions = {
    chart: {
      height: 300,
      type: "column",
      backgroundColor: isDarkTheme ? "#3D3D3D" : "#ffffff",
      options3d: {
        enabled: true,
        alpha: 20,
        beta: 0,
        depth: 100,
      },
    },
    plotOptions: {
      column: {
        depth: 25,
        borderWidth: 0, // Reducir el ancho del borde de las columnas
      },
      series: {
        grouping: false,
        states: {
          inactive: {
            opacity: 1, // Mantiene la opacidad de las otras series
          },
        },
      },
    },
    xAxis: {
      categories: [
        "Nov 2023",
        "Dec 2023",
        "Jan 2024",
        "Feb 2024",
        "Mar 2024",
        "Apr 2024",
        "May 2024",
        "Jun 2024",
        "Jul 2024",
        "Aug 2024",
      ],
      labels: {
        skew3d: true,
        style: {
          fontSize: "16px",
          color: isDarkTheme ? "#ffffff" : "#27403F",
        },
      },
    },
    legend: {
      enabled: true,
      itemStyle: {
        color: isDarkTheme ? "#ffffff" : "#27403F",
      },
    },
    title: {
      text: "",
    },
    yAxis: [
      {
        title: {
          text: "Tickets Resolved",
          margin: 20,
          style: { color: isDarkTheme ? "#ffffff" : "#27403F" },
        },
        labels: {
          style: {
            // fontSize: "16px",
            color: isDarkTheme ? "#ffffff" : "#27403F",
          },
        },
      },
      {
        title: {
          text: "Average Resolution Time (Days)",
          style: { color: isDarkTheme ? "#ffffff" : "#27403F" },
        },
        opposite: true,
        labels: {
          style: {
            // fontSize: "16px",
            color: isDarkTheme ? "#ffffff" : "#27403F",
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Tickets Resolved",
        type: "column",
        data: [1, 1, 3, 14, 107, 817, 917, 887, 891, 1823],
        zIndex: 1,
      },
      {
        name: "Avg Resolution Time",
        type: "line",
        yAxis: 1,
        data: [41, 27, 36, 37, 28, 37, 37, 40, 37, 34],
        marker: {
          enabled: true,
          symbol: "circle",
        },
        zIndex: 2, // La línea tiene un zIndex más alto para que esté al frente
      },
    ],
  };

  return (
    <div className="w-full h-full">
      <Chart options={chartOptions} highcharts={Highcharts} />
    </div>
  );
};

export default TicketsResolutionChart;
